import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";

// Drop-in replacement for <Form.Control type="password" ... /> that adds a
// show/hide toggle. All other props (placeholder, value, onChange, className,
// etc.) pass through unchanged.
const PasswordFormControl = ({ style, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative", ...style }}>
      <Form.Control {...props} type={show ? "text" : "password"} style={{ paddingRight: "36px" }} />
      <span
        onClick={() => setShow((prev) => !prev)}
        role="button"
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#888888",
          fontSize: "18px",
          display: "flex",
        }}
      >
        {show ? <IoEyeOffOutline /> : <IoEyeOutline />}
      </span>
    </div>
  );
};

export default PasswordFormControl;
